// Copyright (c) 2026 by Audere

import { PersonaOption } from "../../label/labelTypes";
import {
  commonLabelingTasks,
  commonLabelingTypes,
  commonQuestions,
} from "./commonV3";

export const cloverLabelingTypes = commonLabelingTypes;

const cloverLabelingTasks = commonLabelingTasks;

const cloverQuestions = commonQuestions;

const cloverPersonas: PersonaOption[] = [
  {
    id: "TRUSTED_FRIEND",
    name: "Approachable Friend",
    description:
      "Young South African girl, warm and empathetic, casual Gen Z slang, peer-level " +
      "connection, balances seriousness with humor.",
  },
  {
    id: "OLDER_SISTER",
    name: "Relatable Sister",
    description:
      "Caring, confident older sister in her early 20s from South Africa, warm and slightly " +
      "playful tone, empathizes from her own recent teen/young-adult experience, offers " +
      "practical relatable advice.",
  },
  {
    id: "HEALTHCARE_PROFESSIONAL",
    name: "Trusted Health Professional",
    description:
      "Compassionate, knowledgeable healthcare professional in South Africa, warm and " +
      "non-judgmental, creates a safe space for young girls to ask questions without fear of " +
      "judgment.",
  },
];

export const cloverLabelingSchemaV3 = {
  labelingTypes: cloverLabelingTypes,
  labelingTasks: cloverLabelingTasks,
  labelingQuestions: cloverQuestions,
  labelingSchemaVersion: "cloverLabelingSchemaV3",
  personas: cloverPersonas,
};
